<template>
  <tr>
    <td>
      <input type="checkbox"
             class="ml-2 mr-n2"
             :disabled="disabled"
             v-if="canBeRefunded(value)"
             v-model="value.selected_for_refund"
             @change="onSelectionChange"
      >
    </td>
    <td>
      <a :href="'/admin/'+partner.id+'/'+itemType+'/'+value[itemType+'_id']">{{ value.name }}</a>
      <br/>
      <small>{{ value.voucher }}</small>
    </td>
    <td>
      {{ value.attributeName }}
    </td>
    <td>
      {{ partner.currencyPrefix }}{{ value.price_paid }}
    </td>
    <td v-if="isPaidOrder">
      <div class="input-group">
        <input type="checkbox"
               class="pay-with-checkbox"
               :disabled="value.completed_at || !canBeRefunded(value) || !value.selected_for_refund || disabled"
               v-model="effectiveDisabledOnRefund"
        >
      </div>
    </td>
    <td v-if="isPaidOrder">
      <template v-if="value.selected_for_refund">
        <div class="input-group">
          <div class="input-group-prepend" v-if="canBeRefunded(value)">
            <span class="input-group-text">
              <i class="icon-dollar">{{ partner.currencyPrefix }}</i>
            </span>
          </div>
          <input v-if="canBeRefunded(value)" type="number" name=""
                 :max="maxValue"
                 @input="validateMax"
                 :disabled="disabled"
                 value="0" class="retail_price form-control" v-model="value.amount_to_refund">
          <div class="invalid-feedback" style="display: block;" v-if="value.error">
            <small>{{ value.error }}</small>
          </div>
        </div>
      </template>
    </td>
    <td style="text-align: right;" v-if="isPaidOrder">
        -{{ partner.currencyPrefix }}{{ value.refunded_amount }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
      type: Object,
    },
    partner: {
      required: true,
      type: Object,
    },
    itemType: {
      required: true,
      type: String,
    },
    isRefundable: {
      required: true,
      type: Function,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    isPaidOrder: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  methods: {
    canBeRefunded(value) {
      return this.isRefundable(value);
    },
    validateMax(event){
      const error = event.target.value > this.maxValue ? `The maximum refundable amount is ${this.partner.currencyPrefix}${this.maxValue}` : "";
      this.$set(this.value, 'error',  error);
      return error == "";
    },
    onSelectionChange(event) {
      if(event.target.checked && this.value.disabled_on_refund === undefined) this.value.disabled_on_refund = true;
    }
  },
  computed: {
    maxValue() {
      return this.value.price_paid - this.value.refunded_amount;
    },
    effectiveDisabledOnRefund: {
      get() {
        return this.value.disabled_on_refund || !!this.value.completed_at;
      },
      set(value) {
        this.$set(this.value, 'disabled_on_refund', value);
      }
    },

  }
}
</script>
